import React, { useEffect, useState } from 'react'
import Review_Card from '../Review_Card/Review_Card'
import "./TopReviews.css";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleRight } from '@fortawesome/free-solid-svg-icons';
import { useDispatch, useSelector } from 'react-redux';
import { allReviewRating } from '../../../features/reviewRating/reviewRatingSlice';

const TopReviews = ({ id }) => {

    const top_reviews = [
        {
            name: "John Doe",
            image: "/assets/images/explore/top-products/product2.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/explore/top-products/product2.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

        {
            name: "John Doe",
            image: "/assets/images/explore/top-products/product2.png",
            review: "Lorem Ipsum is simply dummy text of the printing and typesetting industry",
            date: "05/11/2024"
        },

    ]

    const dispatch = useDispatch();
    const [showAllReviews, setShowAllReviews] = useState(false);


    const reviews = useSelector((state) => state.reviewRating.all_rating);

    useEffect(() => {
        dispatch(allReviewRating({ product_id: id }))
    }, [dispatch])

    return (
        <div className='TopReviews'>
            <p className='heading'>Top 3 Reviews</p>

            <div className='review_card_holder'>
                {(reviews?.length === 0 || !reviews) && (
                    <p>No reviews available.</p>
                )}

                {(showAllReviews ? reviews : reviews?.slice(0, 3))?.map((review, index) => (
                    <Review_Card key={index} review={review} />
                ))}
            </div>

            {reviews?.length > 3 && (
                <div
                    className='see_all_div'
                    onClick={() => setShowAllReviews(!showAllReviews)}
                >
                    <p>
                        {showAllReviews ? "See Less" : "See All"}
                        <FontAwesomeIcon icon={faAngleRight} />
                    </p>
                </div>
            )}

        </div>
    )
}

export default TopReviews
